import * as yup from "yup";

import {
  endDateValidationRule,
  inProgressSimpleArrayRule,
  inProgressStringRule,
  inProgressWithBoolParentStringRule,
  nullableNumberRule,
  regionsRule,
  requiredStringRule,
  startDateValidationRule,
} from "../../utils/validationUtils";

/**
 * Fields shared between Brand and General
 * Simple and WebBanner will extend this object with their own fields and can overwrite the ones
 *  defined if they need to.
 */

const commonFields = yup.object({
  isRegional: yup.boolean().nullable(),
  regions: regionsRule,
  status: yup.string(),
});

const commonAndLanguageFields = commonFields.shape({
  languages: inProgressSimpleArrayRule(yup.number(), "You must select at least one language."),
});

const vendorAssetLocationRule = inProgressWithBoolParentStringRule(
  "areVendorAssetsProvided",
  "You must provide location of vendor assets provided."
);

/**
 * SIMPLE
 */
export const SimpleSchema = commonAndLanguageFields.shape({
  endAt: endDateValidationRule,
  hasVendorCommitment: yup.boolean().nullable(),
  projectOverview: requiredStringRule("You must specify the project overview."),
  startAt: startDateValidationRule,
});

/**
 * WEB BANNER
 */
export const WebBannerSchema = yup.object({
  hasVendorCommitment: yup.boolean().nullable(),

  languages: inProgressSimpleArrayRule(yup.number(), "You must select at least one language."),
  projectOverview: requiredStringRule("You must specify the project overview."),

  status: yup.string(),

  vendorAssetsLocation: vendorAssetLocationRule,
});

/**
 * Dealer Advertising Schema
 */
export const DealerAdvertisingSchema = commonAndLanguageFields.shape({
  storeNumber: inProgressStringRule("You must specify the store number."),
  storeType: inProgressStringRule("You must specify the store type."),
});

/**
 * Dealer Advertising Schema
 */
export const EDMSchema = commonAndLanguageFields.shape({
  vendorAssetsLocation: vendorAssetLocationRule,
});

/**
 * InStore Digital Schema
 */
export const InStoreDigitalSchema = commonAndLanguageFields.shape({
  background: requiredStringRule("You must specify request details."),
});

/**
 * InStore Print Schema
 */
export const InStorePrintSchema = commonAndLanguageFields.shape({
  background: requiredStringRule("You must specify request details."),
});

/**
 * Paid Media Schema
 */
export const PaidMediaSchema = commonFields.shape({
  endAt: endDateValidationRule,
  numberOfWorkOrdersRequested: nullableNumberRule,
  projectOverview: requiredStringRule("You must specify request details."),
  startAt: startDateValidationRule,
  vendorAssetsLocation: vendorAssetLocationRule,
});
